import { useCallback, useMemo } from 'react';
import { Linking } from 'react-native';
import {
  Box,
  Icon,
  Text,
  Image,
  Button,
  PressableIcon,
} from '@betty/moonlight';
import { Trans } from '@betty/i18n';
import { useDispatch } from '@betty/toolkit/state';
import { openChat } from '@betty/chat/state';
import Config from '@betty/toolkit/config';

function FooterRegulations() {
  const dispatch = useDispatch();

  const onChatPress = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  const playResponsiblyComponents = useMemo(
    () => ({
      connexOntario: (
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => Linking.openURL('https://www.connexontario.ca/')}
        />
      ),
      phoneNumber: (
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => Linking.openURL('tel:1-866-531-2600')}
        />
      ),
    }),
    [],
  );

  const bettyInfoComponents = useMemo(
    () => ({
      betty: (
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => Linking.openURL(Config.PLATFORM_URL)}
        />
      ),
      iGamingOntario: (
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => Linking.openURL('https://igamingontario.ca/en')}
        />
      ),
      AGCO: (
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => Linking.openURL('https://www.agco.ca/')}
        />
      ),
    }),
    [],
  );

  return (
    <Box
      gap="space-400"
      flex={1}
      maxWidth={{
        desktop: 420,
        tablet: 420,
        mobile: '100%',
      }}
    >
      <Button
        variant="secondary"
        locNS="common"
        locKey="liveChat"
        onPress={onChatPress}
        display={{
          desktop: 'flex',
          tablet: 'flex',
          mobile: 'none',
        }}
        marginRight={'auto'}
        leftIcon="supportAgent"
      />
      <Text
        variant="body-s"
        color="darkSurfacePrimary"
        locKey="playResponsibly"
        locNS="account"
      >
        <Trans
          ns="account"
          i18nKey="playResponsibly"
          components={playResponsiblyComponents}
        />
      </Text>
      <Text
        variant="body-s"
        color="darkSurfacePrimary"
        locKey="bettyInfo"
        locNS="account"
      >
        <Trans
          ns="account"
          i18nKey="bettyInfo"
          components={bettyInfoComponents}
        />
      </Text>
      <Box flexDirection="row" alignItems="center" gap="space-400">
        <PressableIcon
          name="iGOLogo"
          height={24}
          width={84}
          onPress={() => Linking.openURL('https://igamingontario.ca/en')}
        />
        <Icon name="plus19" height={32} width={32} />
        <Image name="account.rgCheck" height={40} width={40} />
      </Box>
    </Box>
  );
}

export default FooterRegulations;
